import {Component} from "@angular/core";
import {NavController, NavParams, ViewController} from "ionic-angular";
import {CartService} from "../../app/services/cart.service";
import {Cart} from "../../app/classes/cart";
import {Product} from "../../app/classes/product";
import {DEFAULT_INGREDIENTS} from "../../app/constants/config";
import {PricePipe} from "../../app/pipes/getPrice";
import {Customer} from "../../app/classes/customer";
import {Http} from "@angular/http";

/*
 Generated class for the ProductOption page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-product-option',
  templateUrl: 'product-option.html',
  providers: [CartService, PricePipe]
})
export class ProductOptionPage {
  public cart: Cart;
  public productIdentifier;
  public product: Product;
  public selectedSize: number;
  public selectedVariation: number;
  public defaultIngredients: any;
  public addMessage: boolean = false;
  public message: string;
  constructor(public cartService: CartService, public http: Http, public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams) {
    this.cart = cartService.getCart();
    const originalProduct = navParams.get('product') as Product;
    this.productIdentifier = originalProduct.identifier;
    this.selectedVariation = originalProduct.selectedVariation || 0;
    // Create a copy because otherwise changed ingredients bleed into parent(and subsequent) views.
    this.product = new Product(originalProduct.getPayload(), originalProduct.getCategory());
    const customer : any = Customer.cachedOrCreate(this.http);
    this.defaultIngredients = JSON.parse(JSON.stringify(customer.defaultIngredients));
    this.product.message = originalProduct.message;
    for (let i = 0; i < originalProduct.prices.length; i++) {
      const price = originalProduct.prices[i];
      if (price.name == originalProduct.meta.name) {
        this.selectedSize = i;
      }
    }

    this.addMessage = !!this.product.message;
    this.message = this.product.message;

    if (originalProduct.addedIngredients.length || originalProduct.removedIngredients.length) {
      this.defaultIngredients = this.defaultIngredients.map(defaultIngredient => {
        for (let j = 0; j < originalProduct.addedIngredients.length; j++) {
          let ingredient = originalProduct.addedIngredients[j];
          if (defaultIngredient.name == ingredient.name) {
            defaultIngredient.included = true;
          }
        }

        for (let j = 0; j < originalProduct.removedIngredients.length; j++) {
          let ingredient = originalProduct.removedIngredients[j];
          if (defaultIngredient.name == ingredient.name) {
            defaultIngredient.included = false;
          }
        }

        return defaultIngredient;
      });

      this.product.ingredients = this.product.ingredients.map(ingredient => {
        originalProduct.removedIngredients.forEach(removedIngredient => {
          if (ingredient.name == removedIngredient.name) {
            ingredient.included = false;
          }
        });

        return ingredient;
      });
    }

    // Default to first available size
    if (!this.selectedSize) {
      this.selectedSize = 0;
    }

    // filter added ingredients from default ingredients:
    this.defaultIngredients = this.defaultIngredients.filter((ing) => {
      let keep = true;

      if (ing.included_categories){
        keep = ing.included_categories.find(c=>this.product.category.id === c);
      }

      if (ing.excluded_categories){
        keep = keep && !ing.excluded_categories.find(c => this.product.category.id === c)
      }

      this.product.ingredients.forEach((ing2) => {
        if (ing2.title == ing.title) {
          keep = false;
        }
      });
      return keep;
    });

    // sort ingredients
    this.defaultIngredients = this.defaultIngredients.sort((a, b) => {
      let [firstCap, lastCap] = [a.title[0], b.title[0]].map(e => e.toUpperCase());
      if (firstCap < lastCap){
        return -1;
      }
      if (firstCap > lastCap){
        return 1;
      }
      return 0;
    });
  }

  exit() {
    this.viewCtrl.dismiss(this.product);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addProduct() {
    if (this.selectedVariation !== undefined) {
      this.product.setVariation(this.product.variations[this.selectedVariation], this.selectedVariation);
    }
    if (this.selectedSize as any !== false) {
      this.product.setMeta(this.product.prices[this.selectedSize || 0], this.selectedSize || 0);
    }

    // get removed/added ingredients
    let added = [], removed = [];
    this.defaultIngredients.forEach((defaultIngredient) => {
      if (defaultIngredient.included) {
        added.push(defaultIngredient)
      }
    });

    this.product.ingredients.forEach(ingredient => {
      if (!ingredient.included) {
        removed.push(ingredient as any);
      }
    });

    this.cart.products = this.cart.products.filter((prod) => {
      return (prod.identifier !== this.productIdentifier);
    });

    this.cart.addProduct(this.product, {
      added,
      removed,
      message: this.product.message,
    });

    this.viewCtrl.dismiss(this.product);
  }
}



// WEBPACK FOOTER //
// ./src/pages/product-option/product-option.ts